import React from 'react';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';

interface Props {
  onRetry(): void;
}

export const GoalCardError = ({ onRetry }: Props) => {
  return (
    <Box as="li">
      <Card px="16" py="24" css="height:100%">
        <ErrorState onAction={onRetry} height="100%" />
      </Card>
    </Box>
  );
};
